import { AuthPages } from './types'

export const AUTH_ID_COOKIE = '_lcat_id'

export const DEFAULT_PAGES: AuthPages = {
  login: '/account/login',
  register: '/account/register',
}
